<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-wrench me-2"></i>Manutenções / OS</h1>
          <p class="page-subtitle" *ngIf="contractNumber">Contrato: {{ contractNumber }} — {{ contractName }}</p>
        </div>
        <div class="d-flex align-items-center gap-2">
          <select class="form-select form-select-sm status-filter" [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange()">
            <option value="">Todos os status</option>
            <option value="Aberto">Aberto</option>
            <option value="Em Andamento">Em Andamento</option>
            <option value="Fechado">Fechado</option>
            <option value="Cancelado">Cancelado</option>
          </select>
        </div>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="manutencoes"></app-b2b-operational-nav>

    <div class="b2b-ops-card">

      <div *ngIf="!isLoading && items.length === 0" class="b2b-ops-empty">
        <i class="fas fa-wrench"></i>
        <h3>Nenhuma OS vinculada</h3>
        <p>As manutenções importadas da planilha (troca de óleo, etc.) aparecem aqui quando a OS tiver <code>B2BContractId</code> deste contrato.</p>
      </div>

      <app-table
        *ngIf="isLoading || items.length > 0"
        [title]="'Ordens de serviço (' + items.length + ')'"
        [data]="items"
        [columns]="columns"
        [actions]="actions"
        [loading]="isLoading"
        [showSearch]="true"
        [disablePagination]="false"
        (actionClick)="onActionClick($event)">
        <app-button
          table-header-action
          text="Exportar Excel"
          color="var(--success-color)"
          height="36px"
          [disabled]="items.length === 0"
          (buttonClick)="exportExcel()">
          <i class="fas fa-file-excel me-2"></i>
        </app-button>
      </app-table>
    </div>
  </div>

  <app-modal [isOpen]="showDetail" [title]="selected?.orderNumber ? ('OS ' + selected?.orderNumber) : 'Detalhe da OS'" size="lg" (close)="closeDetail()">
    <app-loading [show]="detailLoading" message="Carregando serviços..."></app-loading>

    <div *ngIf="!detailLoading && selected" class="os-detail">
      <div class="os-detail-grid">
        <div>
          <span class="label">Placa</span>
          <strong>{{ selected.plate || '—' }}</strong>
        </div>
        <div>
          <span class="label">Status</span>
          <strong>{{ selected.status || '—' }}</strong>
        </div>
        <div>
          <span class="label">Abertura</span>
          <strong>{{ formatDate(selected.openingDate) }}</strong>
        </div>
        <div>
          <span class="label">Agendada</span>
          <strong>{{ selected.isScheduled ? 'Sim' : 'Não' }}</strong>
        </div>
        <div>
          <span class="label">Oficina</span>
          <strong>{{ selected.openingReason || '—' }}</strong>
        </div>
        <div>
          <span class="label">Km</span>
          <strong>{{ selected.openingMileage ?? '—' }}</strong>
        </div>
        <div>
          <span class="label">Prazo</span>
          <strong>{{ formatDate(selected.deadlineDate) }}</strong>
        </div>
        <div>
          <span class="label">Total serviços</span>
          <strong>{{ formatMoney(selected.totalServices) }}</strong>
        </div>
      </div>

      <p class="os-desc" *ngIf="selected.description">{{ selected.description }}</p>

      <h4 class="os-services-title">Serviços / manutenções</h4>
      <div *ngIf="!(selected.services?.length)" class="text-muted">Nenhum serviço lançado nesta OS.</div>
      <table class="table table-sm" *ngIf="selected.services?.length">
        <thead>
          <tr>
            <th>Descrição</th>
            <th class="text-end">Qtd</th>
            <th class="text-end">Unitário</th>
            <th class="text-end">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of selected.services">
            <td>{{ s.description || '—' }}</td>
            <td class="text-end">{{ s.quantity }}</td>
            <td class="text-end">{{ formatMoney(s.unitValue) }}</td>
            <td class="text-end">{{ formatMoney(s.total) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div slot="footer" class="b2b-ops-modal-footer d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeDetail()">Fechar</button>
      <button type="button" class="btn btn-primary" *ngIf="selected?.id" (click)="openServiceOrder(selected!)">
        <i class="fas fa-external-link-alt me-1"></i>Abrir OS completa
      </button>
    </div>
  </app-modal>
</app-side-menu>
